import {
  mapState,
  mapMutations
} from 'vuex'
import { SIDE_NAV_FLOAT, AGENT_ROLE } from '@/constants'
import maEventBus from '@/components/eventbus'
import { apiPostViewType } from '@/services/API/viewType'
import { apiPostUserLanguage } from '@/services/API/authentication'
import {
  UPDATE_VIEW,
  USER_MODULE_NAME
} from '@/store/types'
import * as Settings from '@/infra/settings'
import routesBuilderMixin from '@/mixins/authRoutesBuilder'

export default {
  name: 'sidenav',
  mixins: [routesBuilderMixin],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      agentView: state => state.agentView
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserRole: 'role'
    }),
    isAgentRole: function() {
      return this.stateUserRole === AGENT_ROLE
    },
    showMaLogo: function() { return this.$maDomain }
  },
  methods: {
    ...mapMutations({
      'mutUpdateView': UPDATE_VIEW
    }),
    setActiveLink: function(activePath) {
      const path = this.$route.path
      if (path.indexOf('warranty') !== -1) {
        if (path === `warranty/${activePath}`) {
          return true
        }
      } else {
        return this.$route.path.indexOf(activePath) !== -1
      }
    },
    hasFloatNav: function(item) {
      return item.meta.type === SIDE_NAV_FLOAT && item.children
    },
    setLang: async function(lang) {
      if (lang !== this.$i18n.locale) {
        this.throwNotification(this.$t('notifications.changeLanguage.title'), this.$t('notifications.changeLanguage.body'), 'OK')
        await apiPostUserLanguage(lang)
        Settings.setLocale(lang)
        maEventBus.$emit('language:change')
        setTimeout(function() {
          window.location.reload() // window.location.reload(true) // We need to reload google script so we reload the entire page
        }, 1000)
      }
    },
    changeView: function(value) {
      maEventBus.$emit('view:change')
      this.mutUpdateView(value)
      localStorage.setItem('maAgentView', value)
      this.sendViewType(value)
    },

    /**
     * @function
     * @name sendViewType Sends via api post api the view the user has selected
     */
    sendViewType(value) {
      const agentViewBody = {
        agent_view: value
      }
      apiPostViewType(agentViewBody).catch((err) => {
        const errs = [400, 500, 409]
        const errCode = errs.find(errCode => err.response.status === errCode) || 0
        this.throwNotification(this.$t(`notifications.error.${errCode}.title`), this.$t(`notifications.error.${errCode}.body`), 'KO')
      })
    }
  }
}
